import type { JSX } from 'react';

import { GridRenderCellParams } from '@mui/x-data-grid';

import { CloudColumn } from './cloudColumn';
import { TagsColumn } from './tagsColumn';

export const customColumns: Record<
  string,
  (props: GridRenderCellParams<any, any>) => JSX.Element | null
> = {
  cloud: CloudColumn,
  tags: TagsColumn,
};
